export let apiEndpoint;
export let wsEndpoint;
export let assetsEndpoint;

// check is window is defined
if (typeof window !== 'undefined') {
	if (window.location.hostname === 'localhost') {
		apiEndpoint = 'http://localhost:8010/api';
		wsEndpoint = 'ws://localhost:8020/dcns-ws/';
		assetsEndpoint = 'http://0.0.0.0:180/assets/';
		// assetsEndpoint = 'http://localhost:8111/assets';
	} else if (window.location.hostname === '0.0.0.0') {
		apiEndpoint = 'http://0.0.0.0:8010/api';
		wsEndpoint = 'ws://0.0.0.0:8020/dcns-ws';
		// assetsEndpoint = 'https://assets.d-cine.net/assets/';
		assetsEndpoint = 'http://0.0.0.0:180/assets/';
	} else {
		apiEndpoint = '/api';
		wsEndpoint = 'wss://' + window.location.hostname + '/dcns-ws/';
		assetsEndpoint = 'https://assets.d-cine.net/assets/';
	}

	if (!apiEndpoint) {
		console.error(`No API endpoint found for path ${window.location.pathname}`);
		// Set a default API endpoint or handle the error as needed
	}
}
